import "./app.scss";
import ServiceForm from "./components/ServiceForm";
import desktop from "./assets/images/Desktop.jpg";
import mobile from "./assets/images/Mobile.jpg";
import "./assets/scss/cconsent-bar.css";

function App() {
    return (
        <>
            <div className="main-container">
                <div className="main-image">
                    <img src={desktop} className="background-image" alt=""/>
                    <img src={mobile} className="background-image-mobile" alt=""/>
                </div>
            </div>
            <div className="form-outer-container">
                <div className="form-bg">
                    <ServiceForm/>
                </div>
            </div>
        </>
    );
}

export default App;
